import { fetch } from 'utils/api';

export const apiFetchDefaultStateAgencies = () => {
  return fetch({
    url: '/default_state_agencies',
    method: 'GET',
    dataType: 'default state agencies'
  });
};
